import { gql, useQuery } from '@apollo/client';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_CURRENCY = 'USD';
export const GET_CURRENCY_INFORMATION_QUERY = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"GetCurrencyInformation1Query\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"currency\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"homeCurrency\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"currencyCode\"}}]}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "GetCurrencyInformation1Query"
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "currency"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "homeCurrency"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "currencyCode"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
});
export const useCurrencyCode = () => {
  var _useQuery$data;
  return ((_useQuery$data = useQuery(GET_CURRENCY_INFORMATION_QUERY).data) === null || _useQuery$data === void 0 ? void 0 : _useQuery$data.currency.homeCurrency.currencyCode) || DEFAULT_CURRENCY;
};
export const wireCurrencyCode = WrappedComponent => props => {
  const currencyCode = useCurrencyCode();
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    currencyCode: currencyCode
  }));
};